import { Injectable } from '@angular/core';
import { WeatherOcrContext } from '../models/weather-bonus.models';

@Injectable({
  providedIn: 'root'
})
export class WeatherContextNormalizerService {
  normalize(context: WeatherOcrContext): WeatherOcrContext {
    const compactPostalCode = (context.postalCode || '').replace(/\s+/g, '');

    return {
      ...context,
      merchantName: (context.merchantName || '').trim(),
      streetAddress: (context.streetAddress || '').trim(),
      postalCode: compactPostalCode,
      city: (context.city || '').trim(),
      country: (context.country || 'Sweden').trim() || 'Sweden',
      timezone: (context.timezone || 'Europe/Stockholm').trim() || 'Europe/Stockholm'
    };
  }

  buildAddressCandidates(context: WeatherOcrContext): string[] {
    const normalized = this.normalize(context);
    const formattedPostalCode = this.formatSwedishPostalCode(normalized.postalCode);
    const candidates = [
      [normalized.streetAddress, formattedPostalCode, normalized.city, normalized.country],
      [normalized.streetAddress, normalized.postalCode, normalized.city, normalized.country],
      [normalized.streetAddress, normalized.city, normalized.country],
      [formattedPostalCode, normalized.city, normalized.country],
      [normalized.postalCode, normalized.city, normalized.country],
      [normalized.city],
      [normalized.city, normalized.country],
      [normalized.streetAddress, normalized.city],
      [normalized.merchantName, normalized.city, normalized.country]
    ];

    return candidates
      .map(parts => parts.filter(Boolean).join(', '))
      .filter((candidate, index, all) => candidate.length > 0 && all.indexOf(candidate) === index);
  }

  private formatSwedishPostalCode(postalCode: string): string {
    if (!postalCode || postalCode.length !== 5) {
      return postalCode;
    }

    return `${postalCode.slice(0, 3)} ${postalCode.slice(3)}`;
  }
}
